import React, { useEffect, useState, useContext } from "react";
import { makeStyles } from "@mui/styles"
import {
  Alert, AlertTitle,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Card,
  Grid,
  CardContent,
  IconButton,
  Select,
  Checkbox ,
  MenuItem,
  InputLabel,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
import { Theme} from '@mui/material/styles'
import Draggable from 'react-draggable';
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import moment from "moment";
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { addMaterialAdjustments, getAllMaterialAdjustments, getMaterialsList, removeMaterialAdjustments } from "../../utils/GetPlanning";
import CounterView from "src/components/CounterView";
import { materialText } from "../../utils/GetAML"
import {  getSalesOffices,GetMaterialList } from "../../utils/GetAdmin";
import { TextField } from "@mui/material";
// import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DeleteIcon from '@mui/icons-material/Delete';
import { green, red } from "@mui/material/colors";
import { DisplayRoleContext } from '../../Context_api'

interface Inputs {
  data: any;
  open: any;
  onSave: any;
  onClose: any;
  showLoading:any;
}
export interface MatDetail {
  materialNum: string;
  description: string;
  denominator: number;
  numerator: number;
}

interface MatDesc {
  materialNum: string,
  materialDescription: string,
  materialCount: number,
  caseCount:number
}

const useStyles = makeStyles((theme: Theme) => ({
  table: {},
  submit: {
    position: 'absolute',
    right: theme.spacing(1),
    top: -0.5,
    margin: theme.spacing(3),
  },
  button: {
    marginLeft: theme.spacing(1),
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalGrid: {
    marginTop: theme.spacing(2),
  },
  modalTitle:{
    color: theme.palette.primary.main,
  },
  modalCard: {
  },
  modalInput: {
    paddingLeft: "20px", 
    paddingRight: "20px", 
    width:"350px"
  },   
   buttonProgress: {
    color: red[500],
    position: "absolute",
    top: "50%",
  },
}));

function PaperComponent(props: any) {
  return (
    <Draggable handle="#dri-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export default function AddMaterials(props: Inputs) {
  //console.log("props---->",props)
  const classes = useStyles();
  const {isDisplayOnlyRole}:any = useContext(DisplayRoleContext);
  const [isLoaded, setIsLoaded] = useState(false);
  const [progressLoading, setProgressLoading] = useState(false);
  const [materialDetails, setMaterialDetails] = useState<any[]>([]);
  const [matDetails, setMatDetails] = useState<any[]>([]);
  const today = new Date().setHours(12,0,0,0);
  const tomorrow = new Date(today.valueOf() + (1000 * 3600 * 24));
  const planningDate = props.data.planningDate.toISOString().split('T')[0];
  const [materialList,setMaterialList] = useState<materialText[]>([]);
  //const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  //const [salesOffices, setSalesOffices] = React.useState<any>();
  const [editedRowSalesOffice, setEditedRowSalesOffice] = React.useState<string>(props?.data.plant);
  const [editedRowMaterialNum, setEditedRowMaterialNum] = React.useState<string>("");
  interface filterRowMaterial {
    searchMaterial: any;
  }
  const [rowMaterial, setRowMaterial] = useState<filterRowMaterial>({
   searchMaterial: null,
  });
  const [errorMessage, setErrorMessage] = useState<any>({});
  const [reloadOnClose, setReloadOnClose] = useState(false);
  const [deleteMaterialAdjustment, setDeleteMaterialAdjustment] = useState<any>({});
  const [showPartialSaveAlert, setShowPartialSaveAlert] = useState(false);
  const [autoFocusValue, setAutoFocusValue] = useState(false);
  
  useEffect(() => {
    if (isLoaded) return;
    props.showLoading(true);
    setProgressLoading(true);
    //let SalesOffices:any
    let materialList:any
    Promise.all(
      [
        // (
        //   getSalesOffices(salesOrg).then((v) => {
        //     if(v) SalesOffices = v
        //   })
        // ),
        
        (getMaterialNum(editedRowSalesOffice)),
        (getMaterialsList(props.data.salesOrg).then(
          (v: any) => {
            if(v&&v.matDetails) materialList = v.matDetails;
          })
          ),
        (setTimeout(function() {
          //your code to be executed after 1 second
        getAllMaterialAdjustments(props.data.salesOrg,props.data.plant,props.data.route,planningDate).then(
            (v: any) => {
              if(v&&v.matDetails){
                const extraMats: any = v.matDetails;
                handleAdjustedMaterials(extraMats);
              }
            })
          }, 1000))
      ]
    )
    .then(()=>{
      //setSalesOffices(SalesOffices);
      setMaterialDetails(materialList);
      setIsLoaded(true);
      setProgressLoading(false);
      props.showLoading(false);
    })
    .catch(()=>{setIsLoaded(true);
      setProgressLoading(false);})
  }, [isLoaded, props.data.salesOrg]);

  const getMaterialNum = (plant:any) => {
    //setEditedRowMaterialNum('all');
    setProgressLoading(true);
     GetMaterialList(props.data.salesOrg,plant).then((v) => {
        if(v) setMaterialList(v);
      })
   
  }

  const formatDateLabel = (date: MaterialUiPickersDate, invalidLabel: string) => {
    const inpDate = moment(date);
    return date && inpDate.isValid()
      ? inpDate.format("YYYY/MM/DD")
      : invalidLabel;
  };

  const handleAdjustedMaterials = (adjustedMaterials:any) => {
    const newMatList:any = [];
    for(const adjustedMaterial of adjustedMaterials){
      const newSelectedItem=Object.assign({});
      newSelectedItem.materialNum=adjustedMaterial.material_num;
      newSelectedItem.description=adjustedMaterial.description.description;
      newSelectedItem.startDate=moment((''+adjustedMaterial.start_date).split('T')[0]);
      newSelectedItem.endDate=moment((''+adjustedMaterial.end_date).split('T')[0]);
      newSelectedItem.clearLoad=adjustedMaterial.clear_load;
      newSelectedItem.count=adjustedMaterial.quantity;
      newSelectedItem.guid=adjustedMaterial.guid;
      newSelectedItem.modified=false;
      newMatList.push(newSelectedItem);
    }
    setMatDetails(newMatList);
  }

  const handleAddtoList = () => {
 
    if(rowMaterial.searchMaterial){
    const selectedItem = materialDetails.find((mat:any) => rowMaterial.searchMaterial.material_num=== mat.materialNum);
    const newMatList:any = [...matDetails];
    const newSelectedItem=Object.assign({}, selectedItem);
    //newSelectedItem.startDate=today;
    //newSelectedItem.endDate=today;
    newSelectedItem.clearLoad=false;
    newSelectedItem.count=0;
    newMatList.push(newSelectedItem);
    setMatDetails(newMatList);
  }else{
    setErrorMessage({title:'No Materials Selected',message:'Please select the material to adjust from list'});
  }
  }

  const isPastDate = (date: MaterialUiPickersDate): boolean => {
    const inpDate = moment(moment(date).format('YYYY-MM-DD'));
    if (inpDate.isBefore(moment(planningDate))) {
      return true;
    } else {
      return false;
    }
  }

  const isDatePeriodOverlapping =(startdate: MaterialUiPickersDate, enddate: MaterialUiPickersDate,materialObj:any): boolean => {
    let isStartDateOverlapped = false;
    let isEndDateOverlapped = false;
    let isOverlapped = false;
    const previousMaterialState=Object.assign({},materialObj);
    var materialItems = [...matDetails];
    if (materialItems) {
      const similarItems=materialItems.filter(mat => mat.materialNum === materialObj.materialNum && Object.entries(mat).toString() !== Object.entries(previousMaterialState).toString())
          if(similarItems){
            for(const material of similarItems){
              isStartDateOverlapped = moment(moment(material.startDate).format('YYYY-MM-DD')).isBetween(moment(startdate).format('YYYY-MM-DD'), moment(enddate).format('YYYY-MM-DD'), undefined, '[]');
              isEndDateOverlapped = moment(moment(material.endDate).format('YYYY-MM-DD')).isBetween(moment(startdate).format('YYYY-MM-DD'), moment(enddate).format('YYYY-MM-DD'), undefined, '[]');
              isOverlapped=isStartDateOverlapped||isEndDateOverlapped;
              //console.log("is Period Overlapped::",isOverlapped);
              if(isOverlapped){
                break;
              }
            }
          }
      }
    return isOverlapped;

  }

  const isDatesOverlapping = (date: MaterialUiPickersDate,materialObj:any): boolean => {
    let isOverlapped = false;
    const previousMaterialState=Object.assign({},materialObj);
    var materialItems = [...matDetails];
    if (materialItems) {
      const similarItems=materialItems.filter(mat => mat.materialNum === materialObj.materialNum && Object.entries(mat).toString() !== Object.entries(previousMaterialState).toString())
          if(similarItems){
            for(const material of similarItems){
              isOverlapped = moment(moment(date).format('YYYY-MM-DD')).isBetween(moment(material.startDate).format('YYYY-MM-DD'), moment(material.endDate).format('YYYY-MM-DD'), undefined, '[]');
              if(isOverlapped){
                break;
              }
            }
          }
      }
    return isOverlapped;
  }
  
  const handleStartDateChange = (id:any) =>  (newDate: any) => {
    //console.log(newDate);
     if (moment(newDate).isValid() &&!isPastDate(newDate)) {
    const index = parseInt(id);
    var materialItems = [...matDetails];
    if (materialItems) {
      if(materialItems[index].endDate){
        var endDate     = moment(materialItems[index].endDate).format('YYYY-MM-DD');
        var selectedDate = moment(moment(newDate).format('YYYY-MM-DD'));
        if(selectedDate.diff(endDate, 'days')>0){
          setErrorMessage({title:'Dates Overlapping',message:'Already Planned for selected Date.'});
          return;
        }
      }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
      if(!isDatesOverlapping(newDate,materialItems[index])){
          materialItems[index].startDate = newDate.setHours(12,0,0,0);
          materialItems[index].modified=true;
          setMatDetails(materialItems);

      }else {
        setErrorMessage({title:'Dates Overlapping',message:'Already Planned for selected Date.'});
      }
        }
      } else if(moment(newDate).isValid() && moment(newDate,'MM/DD/YYYY').year().toString().length>3) {
        setErrorMessage({title:'Unable to plan for past.',message:'Please select a date greater or equal to TODAY.'});
      }
      setAutoFocusValue(false);
  }


  const handleEndDateChange = (id:any) =>  (newDate: any) => {
    //console.log(newDate);
     if (moment(newDate).isValid() && !isPastDate(newDate)) {
    const index = parseInt(id);
    var materialItems = [...matDetails];
      if (materialItems) {
        var startDate     = moment(materialItems[index].startDate).format('YYYY-MM-DD');
        var selectedDate = moment(moment(newDate).format('YYYY-MM-DD'));
        if(selectedDate.diff(startDate, 'days')>=0){
          if(!isDatesOverlapping(newDate,materialItems[index])){
              materialItems[index].endDate =newDate.setHours(12,0,0,0);
              materialItems[index].modified=true;
              setMatDetails(materialItems);
            }else {
              setErrorMessage({title:'Dates Overlapping',message:'Already Planned for selected Date.'});
            }
          }else {
            setErrorMessage({title:'Unable to plan for past',message:'Please select a date greater or equal to Start Date.'});
          }
        }
      }else if(moment(newDate).isValid() && moment(newDate,'MM/DD/YYYY').year().toString().length>3) {
        setErrorMessage({title:'Unable to plan for past.',message:'Please select a date greater or equal to TODAY.'});
      }
      setAutoFocusValue(false);
  }
  const handleMaterialChange = (count: any,index: number) => {
    var materialItems = [...matDetails];
    if (materialItems) {
          materialItems[index].count = parseInt(count) || 0;
          materialItems[index].modified=true;
          setMatDetails(materialItems);
          setAutoFocusValue(true);
          //console.log("LOGe:::::::::::::::::::",JSON.stringify(materialItems));
        }
  }

  const handleClearMaterialsAction = (id:any) => (event:any) => {
    const index = parseInt(id);
    var materialItems = [...matDetails];
    if (materialItems) {
          materialItems[index].clearLoad = event.target.checked;
          materialItems[index].modified=true;
          setMatDetails(materialItems);
        }
  };

  const saveAdjustments = async (validMaterials:any) =>{


    await addMaterialAdjustments(props.data.salesOrg,
      {deliveryPlant: props.data.plant,route:props.data.route,matDetails:validMaterials},planningDate, props.data.uuid).then(
      (v: string) => {
        if (v) {
          if(v === "S"){
            
          } else {
            setErrorMessage(v)
            console.warn(v)
          }
        }
      }
    )
  }

  const handleSubmit = () => {
    var materialItems = [...matDetails];
    const isEmptyDates = materialItems.some(el => !el.startDate||!el.endDate);
    setAutoFocusValue(false);
    if(!isEmptyDates){
      confirmSaveAction();
      }else{
        setShowPartialSaveAlert(true);
      }
        //props.onSave(validMaterials);
  }

  const confirmSaveAction = () =>{
    props.showLoading(true);
    var materialItems = [...matDetails];
    let validMaterials:any=[];
    if (materialItems) {
          validMaterials = materialItems.filter((material) => {
            return (material.count !== 0||material.clearLoad) && material.startDate && material.endDate&&material.modified && material.materialNum;
        });
        
        saveAdjustments(validMaterials).then(()=>{
          resetAddMaterials();
          //props.showLoading(false);
          props.onSave();
          setShowPartialSaveAlert(false);
        });
      }
  }

  const confirmDeleteAction = () => {
    if(deleteMaterialAdjustment!== undefined && Object.keys(deleteMaterialAdjustment).length >1){
const {index, material} =Object.assign({},deleteMaterialAdjustment);
    dismissDeleteConfirm();
    props.showLoading(true);
    if(material){
      if(material&&material.guid){
      removeMaterialAdjustments(props.data.salesOrg,
          {deliveryPlant: props.data.plant,route:props.data.route,matDetails:material},planningDate, props.data.uuid).then(
          (v: string) => {
            if (v) {
              if(v === "S"){
                const updatedMatDetails =[...matDetails];
                updatedMatDetails.splice(index,  1);
                setMatDetails(updatedMatDetails);
              } else {
                setErrorMessage(v)
                console.warn(v)
              }
            }
        
        setReloadOnClose(true);
        props.showLoading(false);
          }
        );
      }else{
        const updatedMatDetails =[...matDetails];
        updatedMatDetails.splice(index,  1);
        setMatDetails(updatedMatDetails);
        props.showLoading(false);
      }
    }
  }
  }

  const resetAddMaterials = ()=>{
    setEditedRowMaterialNum('');
    setRowMaterial({
      searchMaterial: null,
     });
     setMatDetails([]);
     setIsLoaded(false);
     setReloadOnClose(false);
  }

  const handleClose = () => {
    resetAddMaterials();
    setAutoFocusValue(false);
    if(reloadOnClose){
      props.onSave();
    }else{
      props.onClose();
    }
  }

  const dismissError = () => {
    setErrorMessage({});
  }
  const showDeleteMaterialConfirm = (index:number,material:any) => {
    setDeleteMaterialAdjustment({
      index:index,
      material:material
    });
    setAutoFocusValue(false);
  }
  const dismissDeleteConfirm = () => {
    setDeleteMaterialAdjustment({});
  }
  let options: any = [];

  if (materialList && materialList.length > 0) {
    options = options.concat(
      materialList.map((s: any) => ({
        data: `${s.material_num_short} - ${s.description}`,
        material_num: s.material_num,
        source: "Material",
      }))
    );
  }
 // console.log(materialList);
  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      aria-labelledby="dri-title"
      PaperComponent={PaperComponent}
      open={props.open}
      onClose={props.onClose}
    >
      <DialogTitle id="dri-title" style={{ cursor: 'move', minWidth: 500 }}>Add Materials to Load
      <Grid item xs={'auto'} md={'auto'} xl={'auto'} className={classes.submit}>
      <Button disabled={isDisplayOnlyRole}  variant="outlined" color="primary" onClick={handleSubmit} className={classes.button}>{"Save"}</Button>
      <Button variant="outlined" color="primary" onClick={handleClose} className={classes.button}>{"Close"}</Button>
      </Grid>
      </DialogTitle>
      <Card className={classes.modalCard}>
          <CardContent>
          <Grid container spacing={1} className={classes.modalGrid}>
            {/* <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
            <InputLabel >Sales Office</InputLabel>
            <Select label="Sales Office" required placeholder='Sales Office' value={editedRowSalesOffice}
                inputProps={{name: 'Sales Office',}}
                className={classes.modalInput}
                disabled
                onChange={(e) => { 
                  getMaterialNum(e.target.value);setEditedRowSalesOffice((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "*"); 
                    }}>
                {(salesOffices)?(Object.entries(salesOffices).map((so: any, i: number) => (
                  
                    <MenuItem key={so[1].code} value={so[1].code}>
                      {so[1].code + " - " + so[1].text}
                    </MenuItem>
                    ))):(<></>)}
            </Select>
            </Grid> */}
            <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
            <Autocomplete
                options={materialList}
                style={{ width: "450px" }}
                value={rowMaterial.searchMaterial}
                getOptionLabel={(option: any) => `${parseInt(option.material_num_short)}-${option.description}`}
                onChange={(_, newMat) => {
                  setRowMaterial({
                    ...rowMaterial,
                    searchMaterial: newMat,
                  });
                  setEditedRowMaterialNum((newMat&&  typeof newMat== 'string') ? newMat: "*"); 
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter" && (event.target as any).value) {
                    const newMat = (event.target as any).value;
                    setRowMaterial({ ...rowMaterial, searchMaterial: newMat });
                    setEditedRowMaterialNum((newMat&&  typeof newMat== 'string') ? newMat: "*");
                  }
                }}
              //  disabled={!editedRowMaterialNum}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search Material"
                    helperText="Select material to be added"
                    variant="standard"
                  />
                )}
              />
            </Grid>
            <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
            <Button disabled={isDisplayOnlyRole} variant="outlined" color="primary" onClick={handleAddtoList}>{"Add to Config"}</Button>
            {progressLoading ? (
              <CircularProgress size={24} className={classes.buttonProgress} thickness={4.5} disableShrink />):(<></>)}
            </Grid>
            </Grid>
            </CardContent>
          </Card>
      <TableContainer component={Paper}>
        <Table className={classes.table} size="small">
          <TableHead>
            <TableRow>
              <TableCell>Material</TableCell>
              <TableCell align="right">From Date</TableCell>
              <TableCell align="right">To Date</TableCell>
              <TableCell align="right">CS</TableCell>
              <TableCell align="right">Clear Load</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {matDetails.map((row, index: number) => {
              const identifier = "" + index;
              return (
                <TableRow key={Date.now()+''+index} selected={true}>
                  <TableCell component="th" scope="row">
                    {Number(row.materialNum).toString()+': '+row.description}
                  </TableCell>
                  <TableCell align="right">
                  <LocalizationProvider  dateAdapter={AdapterDateFns}>
                    <DatePicker value={row.startDate?row.startDate:''} onChange={handleStartDateChange(identifier)} disabled={isDisplayOnlyRole || props.data.isLoading} 
                      renderInput={(props:any) => (
                        <TextField {...props} variant="outlined" label={formatDateLabel} fullWidth />
                      )}
                    />
                  </LocalizationProvider >
                  </TableCell>
                  <TableCell align="right">
                  <LocalizationProvider  dateAdapter={AdapterDateFns}>
                    <DatePicker value={row.endDate?row.endDate:''} onChange={handleEndDateChange(identifier)} disabled={isDisplayOnlyRole || props.data.isLoading} 
                      renderInput={(props:any) => (
                        <TextField {...props} variant="outlined" label={formatDateLabel} fullWidth />
                      )}
                    />
                  </LocalizationProvider >
                  </TableCell>
                  <TableCell align="right">
                    <CounterView  initValue={row.count?row.count:0} identifier={index} handleMaterialChange={handleMaterialChange} autoFocusValue={autoFocusValue} />
                  </TableCell>
                  <TableCell align="right">
                  <Checkbox disabled={isDisplayOnlyRole} checked={row.clearLoad} onChange={handleClearMaterialsAction(identifier)} />
                  </TableCell>
                  <TableCell>
                    <Tooltip title={"Delete Material"}>
                      <IconButton disabled={isDisplayOnlyRole} onClick={() => showDeleteMaterialConfirm(index,row)}>
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="dri-title"
        open={errorMessage !== undefined && Object.keys(errorMessage).length >1}
        onClose={dismissError}
      >
        <DialogContent>
          <Alert severity="error">
            <AlertTitle>{errorMessage.title}</AlertTitle>   
            <Typography paragraph>{errorMessage.content}</Typography>
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={dismissError} color="primary">
            Okay
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="dri-title"
        open={deleteMaterialAdjustment!== undefined && Object.keys(deleteMaterialAdjustment).length >1}
        onClose={dismissDeleteConfirm}
      >
        <DialogTitle id="dri-title">Confirm Delete</DialogTitle>
        <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Do you want to delete {deleteMaterialAdjustment!== undefined && Object.keys(deleteMaterialAdjustment).length >1?Number(deleteMaterialAdjustment.material.materialNum).toString()+': '+deleteMaterialAdjustment.material.description:''}?
        </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => dismissDeleteConfirm()} color="primary">
            No
          </Button>
          <Button onClick={() => confirmDeleteAction()} color="primary" autoFocus>
            Yes, proceed
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="dri-title"
        open={showPartialSaveAlert}
        onClose={dismissDeleteConfirm}
      >
        <DialogTitle id="dri-title">Confirm Save</DialogTitle>
        <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Materials without Start date or End date will be removed. Do you wish to proceed with remaining materials?
        </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {setShowPartialSaveAlert(false);}} color="primary">
            No
          </Button>
          <Button onClick={() => confirmSaveAction()} color="primary" autoFocus>
            Yes, proceed
          </Button>
        </DialogActions>
      </Dialog>
    
    </Dialog>
  );
}
